import React from 'react'
import Nuxallecomp from '../../components/about/nuxalleComp/nuxallecomp'


const Nuxalle = () => {
  return (
    <div>
      <Nuxallecomp />
    </div>
  )
}

export default Nuxalle
